<template>
  <div class="maf-radio">
    <label v-text="name" :style="{ color: labelColor }"></label>
    <span style="color: red" v-show="required">*Required</span>
    <div class="maf-s-raido">
      <div v-for="(opt, index) in options" :key="index">
        <label>
          <input
            type="radio"
            v-model="field"
            :disabled="disabled"
            :value="opt.value"
            @change="change"
          />
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g>
                <rect
                  stroke="url(#greenColor)"
                  x="0.5"
                  y="0.5"
                  width="19"
                  height="19"
                  rx="9.5"
                ></rect>
                <rect
                  fill="url(#greenColor)"
                  x="5"
                  y="5"
                  width="10"
                  height="10"
                  rx="5"
                ></rect>
              </g>
            </g>
          </svg>
          <span v-text="opt.label" :style="{ color: labelColor }"></span>
          <span class="tip-icon reduced-tip" v-if="tip" ref="tipIcon">
            <p v-text="tip"></p>
          </span>
          <span class="amount" v-text="opt.amount" v-show="opt.amount"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MafRadio',
  props: {
    value: {
      type: String,
      default() {
        return '';
      },
    },
    name: {
      type: String,
      default() {
        return '';
      },
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    target: {
      type: Object,
      default() {
        return {};
      },
    },
    tip: {
      type: String,
      default() {
        return '';
      },
    },
    required: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isImmigration: {
      type: Boolean,
      default() {
        return false;
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  mounted () {
    this.$on('invalid', (err) => {
      this.error = err || 'This field is required'
    })
  },
  data: function () {
    return {
      field: '',
      error: '',
      labelColor: '',
      isPopup: ''
    }
  },
  watch: {
    'target.Income_Type__c': function(val, oldVal) {
      if (val !== oldVal && oldVal) {
        this.$parent.handleFieldsChange(this.target)
      }
    },

    'value': function(val, oldVal) {
      this.field = val
    },

    'field': function(val, oldVal) {
      this.error = ''
      this.$emit('input', val)
    },
  },
  methods: {
    setRadioColor() {
      this.labelColor = '#F44236'
      this.isPopup = true
    },
    change () {
    }
  },
  computed: {}
};
</script>

<style scoped lang="scss">
@import './../../sass/flex-layout.scss';
  .maf-s-raido label {
    display: flex;
    align-items: center;
  }

  .maf-s-raido input {
    width: 0;
    height: 0;
    border: 0;
    clip: rect(0 0 0 0);
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
  }

  .maf-s-raido input:checked ~ span {
    font-family: San Francisco Weight;
  }

  .maf-s-raido input:not(:checked) ~ svg rect:first-child {
    stroke: #c6c9cf;
  }

  .maf-s-raido input:not(:checked) ~ svg rect:last-child {
    fill: none;
  }

  .maf-s-raido svg {
    flex-shrink: 0;
    margin-right: 20px;
  }

  .maf-s-raido div {
    margin-top: 11px;
  }

  .maf-s-raido span {
    font-size: 16px;
    letter-spacing: 0.35px;
  }

  .tip-icon {
  position: relative;
  display: inline-block;
  text-align: center;
  background-color: #834bc4;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 15px;
  line-height: 22px;
  margin-left: 20px;
  cursor: pointer;
  font-family: San Francisco !important;
}

.tip-icon:before {
  content: '?';
  color: #fff;
}

.tip-icon:hover p {
  display: block;
  transform-origin: 100% 0%;
  -webkit-animation: fadeIn 0.3s ease-in-out;
  animation: fadeIn 0.3s ease-in-out;
}

.tip-icon p {
  display: none;
  text-align: left;
  background-color: #6b40be;
  padding: 16px;
  width: 200px;
  position: absolute;
  border-radius: 5px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  bottom: 32px;
  color: #fff;
  font-size: 0.9rem;
  line-height: 1.4;
  z-index: 1000;
  cursor: default;
  right: -192px;
}

.tip-icon p:before {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border: 12px solid transparent;
  border-top-color: #6446b7;
  left: -12px;
  bottom: -8px;
  transform: rotate(135deg);
}

.reduced-tip {
  margin-left: 10px;
}

@media screen and (max-width: 768px) {
  .tip-icon p {
    right: 10px;
    width: calc(100vw - 250px);
  }

  .tip-icon p:before {
    left: auto;
    right: 0px;
    bottom: -8px;
    transform: rotate(90deg);
  }

  .reduced-tip {
    right: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/MafRadio.vue